import { render } from "./ApplicationSummaryLabel.vue?vue&type=template&id=c893d41c"
import script from "./ApplicationSummaryLabel.vue?vue&type=script&lang=js"
export * from "./ApplicationSummaryLabel.vue?vue&type=script&lang=js"

import "./ApplicationSummaryLabel.vue?vue&type=style&index=0&id=c893d41c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__